import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { lastValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isAuthRoute = state.url.includes('/auth');
  const isSessionValid = await lastValueFrom(authService.validateSession());

  if (!isSessionValid) {
    authService.removeUserData();
  }

  if (isAuthRoute && isSessionValid) {
    return router.createUrlTree(['/']);
  }

  if (!isAuthRoute && !isSessionValid) {
    return router.createUrlTree(['/auth/login']);
  }

  return true;
};
